import React from "react";
import { DotsLoader } from "@activecollab/components";
import PropTypes from "prop-types";
import TimeRecordFormListItemContainer from "./TimeRecordFormListItemContainer.jsx";
import { timeRecordShape } from "../Timesheet/shapes/index.jsx";
import { useTimeRecordModalContext } from "../Tracking/context/TimeRecordModalContext.jsx";

const TimeRecordFormList = ({ timeRecords, className, onEdit, onTimeRecordEdit }) => {
  const { isLoadingMore = false } = useTimeRecordModalContext();

  return (
    <div className={className}>
      {timeRecords.map((timeRecord) => (
        <TimeRecordFormListItemContainer
          key={`time-record-form-list-item-${timeRecord.id}`}
          id={timeRecord.id}
          onEdit={onEdit}
          onTimeRecordEdit={onTimeRecordEdit}
        />
      ))}
      {isLoadingMore ? (
        <div className="tw-text-center tw-py-8">
          <DotsLoader />
        </div>
      ) : null}
    </div>
  );
};

TimeRecordFormList.propTypes = {
  timeRecords: PropTypes.arrayOf(timeRecordShape),
  className: PropTypes.string,
  onEdit: PropTypes.func,
  onTimeRecordEdit: PropTypes.func,
};

TimeRecordFormList.defaultProps = {
  timeRecords: [],
};

export default TimeRecordFormList;
